import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  get,
  groupBy,
  orderBy,
  sortBy,
} from 'lodash';
import Lightbox from 'react-images';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import CircularProgress from '@material-ui/core/CircularProgress';
import Visibility from '@material-ui/icons/Visibility';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import {
  formatPrice,
  getOrganizationUID,
  decimalFixed,
  toStartCase,
} from 'helpers/utils';
import {
  injectIntl,
  Pagination,
  Tags,
  HighlightText,
} from 'components';
import StoreTable from './StoreTable';
import CategoryDrawer from '../../OrderSheet/components/CategoryDrawer';

const styles = () => ({
  sortBtnLabel: {
    color: '#9e9e9e',
    fontSize: 12,
    textTransform: 'none',
  },
  button: {
    backgroundColor: '#fff',
    borderRadius: 5,
    marginBottom: 5,
    marginLeft: 10,
  },
  buttonLabel: {
    color: '#4695ec',
    fontSize: 10,
    fontWeight: 600,
  },
  activeButton: { backgroundColor: '#4695ec' },
  activeButtonLabel: { color: '#fff' },
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
  },
  tab: { backgroundColor: '#ffffff', minWidth: 80 },
  tabIndicator: { backgroundColor: '#5b98ed' },
  tabLabel: {
    fontWeight: 600,
    color: '#5b98ed',
  },
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '0px 1px 0px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12)',
    borderRadius: '1px !important'
  },
  cardMedia: {
    paddingTop: '60%',
  },
  cardContent: {
    flexGrow: 1,
    paddingLeft: '8px',
    paddingRight: '8px',
    paddingBottom: '5px !important'
  },
  cardMobile: {
    height: '100%',
    display: 'flex',
    flexDirection: 'row',
  },
  cardMediaMobile: {
    width: '80px',
  },
  cardContentMobile: {
    flexGrow: 1,
    paddingLeft: '10px',
    paddingRight: '10px',
    paddingTop: '8px',
    paddingBottom: '10px !important'
  }	
});

class StoreCardDetails extends Component {
  static contextTypes = {
    currentUser: PropTypes.shape({}),
  };

  static propTypes = {
    classes: PropTypes.shape({}).isRequired,
    details: PropTypes.arrayOf(
      PropTypes.shape({}),
    ),
    history: PropTypes.shape({
      location: PropTypes.shape({
        search: PropTypes.string,
      }).isRequired,
    }).isRequired,
    requesting: PropTypes.bool,
    sortDirection: PropTypes.string,
    sellers: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]),
    })).isRequired,

    formatMessage: PropTypes.func.isRequired,
    isMobile: PropTypes.bool,
    accessToken: PropTypes.string,
  };

  static defaultProps = {
    details: [],
    requesting: false,
    sortDirection: '',
    isMobile: false,
    accessToken: null,
  };

  state = {
    activePageIndex: 1,
    currentCategory: null,
    filterCategories: [],
    tableMode: 0,
    open: false,
    dialogMessage: '',
    lightboxIsOpen: false,
    currentImage: 0,
    categoryFilter: "",
  };

  componentWillMount() {
    this.refreshCategories(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.details !== nextProps.details) {
      this.refreshCategories(nextProps);
    }
  }

  closeLightbox = () => this.setState({ currentImage: 0, lightboxIsOpen: false })

  gotoPreviousImage = () => this.setState({ currentImage: this.state.currentImage - 1 })

  gotoNextImage = () => this.setState({ currentImage: this.state.currentImage + 1 })

  gotoImage = index => this.setState({ currentImage: index })

  handleClickLightboxImage = () => {
    if (this.state.currentImage === this.lightboxImages.length - 1) return;
    this.gotoNextImage();
  }

  onPageClick = (index) => {
    this.setState({ activePageIndex: index });
  }

  getData = () => {
    const { details, sortDirection } = this.props;
    const { currentCategory } = this.state;
    let groupItemsInfo = [];

    if (!details) return [];

    if (currentCategory){
      const newInfo = groupBy(details, item => item.productData.category);
      groupItemsInfo = newInfo[currentCategory] || []
    }else{
      groupItemsInfo = details;
    }

    const nameField = r => r.productData.name;
    const subNameField = r => r.productData.subname;
    const categoryNameField = r => currentCategory ? currentCategory : r.productData.category;
    const sortedGroupItems = sortDirection
      ? orderBy(groupItemsInfo, ['updatedAt', 'approved', nameField, subNameField, 'index'], [sortDirection, 'asc', 'asc', 'asc', 'asc'])
      : orderBy(groupItemsInfo, ['approved', nameField, subNameField, 'index']);
    const filteredData = [];

    sortedGroupItems.forEach((groupItemInfo) => {
      filteredData.push({
        ...groupItemInfo,
        sourcename: get(groupItemInfo, 'user.account.profile.companyName') || '',
      });
    });

    const sortedFilteredData = sortDirection
      ? orderBy(filteredData, ['updatedAt'], [sortDirection])
      : orderBy(filteredData, categoryNameField);

    return sortedFilteredData;

  }

  getDataForPagination = (sortedFilteredData) => {
    const { activePageIndex } = this.state;
    const slicedData = sortedFilteredData.slice((activePageIndex - 1) * 100,
      activePageIndex * 100 || sortedFilteredData.length);

    return slicedData;
  }

  handleClickOpen = (dialogMessage) => {
    this.setState({ open: true, dialogMessage });
  };

  handleClose = () => {
    this.setState({ open: false, dialogMessage: '' });
  };

  getFields = (isMobile = false) => {
    const { currentUser } = this.context;
    const {
      formatMessage,
      sellers,
      classes,
    } = this.props;

    const sellerIds = sellers.map(({ sellerId }) => sellerId);

    const qty = row => (
      <div style={{ paddingRight: 5, width: '100%' }} className="normal-font red">
        <span className={`${row.approved ? 'normal-font' : 'disable'}`}>
          {row.availableQuantity === '' ? '0' : Math.trunc(parseFloat(row.availableQuantity))}
        </span>
      </div> || '0'
    );

    const bulk = row => (
      <span className="qty-alert">
        {
          row.isBulk ? (
            <span className={`${row.isBulk && row.isMinCount ? '' : 'hide'} ${row.approved ? 'normal-font' : 'disable'}`}>
              {row.bulkTotalQty === '' ? '0' : decimalFixed(row.bulkTotalQty)}
            </span>
          ) : (
            ''
          )
        }
      </span>
    );

    const fields = [];

    if (isMobile) {
      fields.push({
        label: '',
        render: row => (
          <div className="mobile-group-data-first">
            <div className={`mobile-group-data-item mr-2 highlight weight-500`}
              style={{fontSize:'20px'}}
            >
              <HighlightText
                highlight={''}
                text={[row.name, row.subname].join(', ')}
              />
            </div>
            {
              row.tags ? (
                <div className={classes.flexWrap}>
                  <Tags
                    approved={row.approved}
                    defaultTags={row.tags}
                    removable={false}
                    showDropdown={false}
                    size="small"
                  />
                </div>
            ) : null
            }
            <div className="ml-2">
                {row.image ? (
                  <img
                  src={row.image}
                  alt={row.image}
                  style={{
                    height: 50,
                    objectFit: 'unset',
                    width: 50,
                    cursor: 'pointer',
                  }}
                  onClick={() => this.openLightbox(row)}
                />
                ) : null}
            </div>
          
          </div>
        ),
      });
      fields.push({
        label: '',
        render: (row) => {
          const rowId = `${row.id}_${row.index}`;
          return (
            <div className={`mobile-group-data row ml-0 mr-0 mt-2 ${row.isBulk ? 'mb-2' : ''}`}>
              <div
                style={{ justifyContent: 'flex-start', fontSize:'14px' }}
                className="mobile-group-data-item normal-font col-4 pl-0 pr-0 ">
                {row.count} {row.uom} {row.pack}
              </div>
              <div style={{ justifyContent: 'center', fontWeight: '500' }} className="price-group d-flex mobile-group-data-item col-4">
                {/* Total Price */}
                {currentUser.id && (
                  <span>
                    <span style={{
                      alignItems: 'center',
                      color: 'black',
                      display: 'flex',
                      justifyContent: 'center',
                    }}>
                      $&nbsp;{row.price === '0.00' || !row.price ? '0.00' : row.price}
                    </span>
                  </span>
                )}
                {/* Price */}
                {currentUser.id && (
                  <span className="grey" style={{ paddingLeft: '8px', color: '#459dfe' }}>
                    <span>
                      ${formatPrice(((row.cost * (100 - (row.discount || 0))) / 100))}
                    </span>
                  </span>
                )}
              </div>
              { row.isBulk && (<div>{bulk(row)}</div>)}
              <div className="small-font col-3 pr-0">
                <span className="d-flex" style={{ justifyContent: 'center', alignItems: 'center' }}>
                  <span className="red d-flex" style={{ alignItems: 'center' }}>{qty(row)}&nbsp;</span>
                  <span style={{ marginRight: 10 }} className="italic">
                    {formatMessage('left')}
                  </span>
                </span>
              </div>
            </div>
          );
        },
        title: () => '',
      },
      {
        className: 'info',
        colSpan: 2,
        label: '',
        name: 'description',
        render: row => ( 
          <div style={{marginTop: '10px', marginBottom:'10px'}} >
            {row.description}
          </div> ),
         title: () => '',
      } );
    
      fields.push({
        label: '',
        name: 'sourcename',
        className: 'normal-font',
        render: row => (
          <Link to={`/shop@${getOrganizationUID(row.sourcename)}`}>
            <Visibility style={{ verticalAlign: 'middle', marginRight: 3, fontSize: '20px' }} />
            {row.sourcename}
          </Link>
        ),
      });

    } else {
      fields.push({
        className: 'image',
        colSpan: 1,
        label: '',
        mobileHidden: true,
        name: 'image',
        render: row => (
          row.image ? <img src={row.image} alt="" style={{ width: 40, height: 40 }} onClick={() => this.openLightbox(row)} /> : null
        ),
        title: () => '',
      });
      fields.push({
        className: 'category ',
        colSpan: 2,
        label: formatMessage('Category'),
        name: 'category',
        render: data => (
          <div className="category-pane">
            <span className="small-font category-title">
                {data.category}
            </span>
          </div>
        ),
        title: row => row.category,
      });
      fields.push({
        className: 'highlight normal-font large-font-for-mobile',
        colSpan: 3,
        label: formatMessage('IN'),
        name: 'name',
        render: data =>
          (
            <span className="item-name-pane font-weight-500 ">
              <div title={data.name}>
                  {data.name}
              </div>
            </span>
          ),
        title: row => row.name,
      });
      fields.push({
        className: 'highlight normal-font big-font-for-mobile',
        colSpan: 2,
        label: formatMessage('ISN'),
        name: 'subname',
        render: data => (
          <span className="normal-font">
            {data.subname}
          </span>
        ),
        title: row => row.subname,
      });
      fields.push({
        className: 'info',
        colSpan: 2,
        label: formatMessage('Info'),
        name: 'description',
        render: row =>  (
          <span style ={{lineHeight:'15px'}}>
          {row.description ? (`${row.description.substr(0, 57)}${row.description.length > 57 ? '...' : ''}`) : ''}
          </span>),
        title: row => row.description,
      });
      fields.push({
        colSpan: 3,
        label: formatMessage('Tags'),
        name: 'tags',
        render: data => (data.tags ? (
          <div className={classes.flexWrap}>
            <Tags
              approved
              defaultTags={data.tags}
              removable={false}
              showDropdown={false}
              size="small"
            />
          </div>
        ) : null),
      });
      fields.push({
        colSpan: 2,
        label: formatMessage('Qty'),
        name: 'totalQtyByPack',
        render: row => qty(row),
        title: formatMessage('Qty By Pack'),
      });
      fields.push({
        className: 'highlight',
        colSpan: 2,
        label: formatMessage('Pack-Out'),
        name: 'uom',
        render: data => <span className="normal-font">{`${data.count} ${data.uom} ${data.pack}`}</span>,
        title: data => `${data.count} ${data.uom} ${data.pack}`,
      });
   
      fields.push({
        colSpan: 2,
        label: formatMessage('Storefront'),
        name: 'sourcename',
        className: 'normal-font',
        render: row => (
          <Link to={`/shop@${getOrganizationUID(row.sourcename)}`}>
            <Visibility style={{ verticalAlign: 'middle', marginRight: 3 }} />
            {row.sourcename}
          </Link>
        ),
      });

      if (currentUser.id) {
        fields.push({
          className: 'normal-font',
          label: formatMessage('Price'),
          name: 'price',
          render: row => (
            !row.user || sellerIds.indexOf(row.user.accountId) === -1 ? '-' : `$${formatPrice(row.price)}`
          ),
          title: () => '',
        });
      }
      fields.push({
        colSpan: 2,
        label: formatMessage('Storefront'),
        name: 'sourcename',
        className: 'normal-font',
        render: row => (
          <Link to={`/shop@${getOrganizationUID(row.sourcename)}`}>
            {row.sourcename}
          </Link>
        ),
      });
   
    }

    fields.push({ label: '', name: 'action', colSpan: 1 });

    return fields;
  }

  openLightbox = (item) => {
    const imageIndex = this.lightboxImages.findIndex(i => i.itemId === item.id);
    this.setState({ currentImage: imageIndex >= 0 ? imageIndex : 0, lightboxIsOpen: true });
  }

  handleItemClick = (row) => {
    const { history } = this.props;
    history.push(`/products/${row.id}`);
  }

  changeFilterCategories = (categoryName) => {
    this.setState({ currentCategory: categoryName, activePageIndex: 1 });
  }

  refreshCategories = (props) => {
    const newInfo = groupBy(props.details, item => item.productData.category);
    const originalCategories = sortBy(Object.keys(newInfo));

    const categories = [];
    originalCategories.forEach((detail) => {
      categories.push({ name: detail, length: newInfo[detail].length });
    });

    this.setState({ filterCategories: categories, currentCategory: null });
  }

  toggleFortableMode = (event, toggled) => {
    this.setState({ tableMode: toggled });
  }

  checkIsAllowedZero = (contact) => {
    const { isPublic } = this.context;
    const sellerRoleId = get(contact, 'sellerProfile.roleId');
    const sellerRole = {
      2: 'Buyer',
      3: 'Distributor',
      4: 'Seller',
      5: 'Consumer',
    }[sellerRoleId] || 'Personal';

    const buyerRoleId = get(contact, 'buyerProfile.roleId');
    const buyerRole = {
      2: 'Buyer',
      3: 'Distributor',
      4: 'Seller',
      5: 'Consumer',
    }[buyerRoleId] || 'Personal';

    return isPublic ? true : (sellerRole === 'Seller' && (buyerRole === 'Buyer' || buyerRole === 'Consumer' || buyerRole === 'Personal'));
  }

  getDataGrouped = (data) => {
    const { contact } = this.props;
    const isAllowedZero = this.checkIsAllowedZero(contact);
    const modifiedData = [];
    if (!data) return [];
    if (data) {
      let packRowCount = 0;
      data.packrows.forEach((packrow) => {
        if (parseFloat(packrow.availableQuantity, 10) === 0 && !isAllowedZero) return;
        packRowCount++;
        if (packRowCount > 1) {
          modifiedData.push({
            category: toStartCase(data.productData.category),
            ...data,
            ...packrow,
            hide: [
              'action',
              'category',
              'description',
              'image',
              'name',
              'sourcename',
              'status',
              'subname',
              'tags',
              'updatedAt',
            ],
            id: data.id,
            name: data.productData.name,
            subname: data.productData.subname,
          });
          return;
        }
        modifiedData.push({
          category: toStartCase(data.productData.category),
          ...data,
          ...packrow,
          id: data.id,
          name: data.productData.name,
          subname: data.productData.subname,
        });
      });
    }

    return modifiedData;
  };

  handleClick = (e) => {
    const value = e.currentTarget.innerText.trim() === "All" ? "" : e.currentTarget.innerText;
    this.setState({ currentCategory: value });
    if (isMobile) {
      this.setState({ drawerOpen: false });
    } 
  }


  render() {
    const {
      classes,
      formatMessage,
      requesting,
      sellers,
      isMobile,
      accessToken,
    } = this.props;
    const {
      activePageIndex,
      currentCategory,
      filterCategories,
      tableMode,
      open,
      dialogMessage,
      currentImage, 
      lightboxIsOpen,
      categoryFilter,
    } = this.state;
    const listCategories =  filterCategories ? Object.keys(groupBy(filterCategories, item => item.name)) : [];    
    const filteredData = this.getData();
    const slicedData = this.getDataForPagination(filteredData);
    const fields = this.getFields();
    const fieldsForMobile = this.getFields(true);
    debugger;
    this.lightboxImages = slicedData.filter(g => !!g.image)
    .map(({ id, image, productData }) => ({
      itemId: id,
      src: image,
      caption: `${productData.category} - ${productData.name}, ${productData.subname}`,
    }));
    let actualCategory = "";
    const sellerIds = sellers.map(({ sellerId }) => sellerId);

    return (
      <div className={`store-detail loading-enabled ${requesting && filteredData.length ? 'loading' : ''}`} style={{display:'flex'}}>
        {/* categry drawer */}
        {!isMobile && listCategories.length !=0 &&
          <div className="category-container">
            <CategoryDrawer 
              products={listCategories}
              handleClick={this.handleClick}
              categoryFilter={currentCategory}
              />
          </div>
        }
        <div>
        <div className="filter-categories">
          {
            filterCategories.map((category, index) => (
              <Button
                classes={{
                  label: `${classes.buttonLabel} ${category.name === currentCategory ? classes.activeButtonLabel : ''}`,
                  root: `${classes.button} ${category.name === currentCategory ? classes.activeButton : ''}`,
                }}
                key={index}
                onClick={() => this.changeFilterCategories(category.name)}
                variant="contained"
              >
                {`${category.name} (${category.length})`}
              </Button>
            ))
          }
        </div>
        {
          requesting && !slicedData.length && (
            <div className="store-progress">
              <CircularProgress />
            </div>
          )
        }
        {
          tableMode ? (
            slicedData.length ?
              <div className="grid-view">
                <div className="smart-table">
                  {
                    <StoreTable
                      fields={fields}
                      threshold="md"
                    >
                      {
                        slicedData.map((tempDataItem, index) => (
                          <StoreTable.StoreTableRow
                            data={tempDataItem}
                            fields={fields}
                            formatMessage={formatMessage}
                            key={index}
                          />
                        ))
                      }
                    </StoreTable>
                  }
                  {
                    <StoreTable.StoreMobileTable
                      threshold="md"
                    >
                      {
                        slicedData.map((tempDataItem, index) => (
                          <StoreTable.StoreMobileTableRow
                            data={tempDataItem}
                            fields={fieldsForMobile}
                            formatMessage={formatMessage}
                            key={index}
                            threshold="md"
                          />
                        ))
                      }
                    </StoreTable.StoreMobileTable>
                  }
                </div>
              </div>
              : ''
          ) : (
              <div className={`grid-view ${classes.root}`}>
                <Grid container spacing={24} style={!isMobile ? { maxWidth: '1200px', margin: 'auto' } : {}}>
                  {sortBy(slicedData, ['category', 'productData.name', 'packrows[0].count']).filter(item => item.approved).map((item, index) => {
                    const data = this.getDataGrouped(item);

                    return (
                      data.filter(row => row.user && !row.user.account.profile.isOff).map((row, index) => {

                        const imageUrl = row.image || '/assets/images/image-not-available-1.png';
                        const val = formatPrice(((row.price * (100 - (row.discount || 0))) / 100)).toString();
                        const dec_pos = val.indexOf('.');
                        const showCategoryTitle = actualCategory === row.category ? false : true;
                        actualCategory = row.category;

                        return (
                          isMobile ? (
                            <Grid item key={index} xs={12} sm={12} md={12} style={{ padding: 0 }}>
                              {showCategoryTitle && <div style={{ fontSize: 22, fontWeight: 300, color: "grey", paddingBottom: 15, paddingTop: 15, paddingLeft: 15, textAlign: "left" }}>{row.category}</div>}
                              <Card className={classes.cardMobile}>
                                <div>
                                  <img src={imageUrl} alt="" width="170" height="130" style={{ objectFit: 'cover' }}></img>
                                </div>
                                <CardContent className={classes.cardContentMobile}>
                                  <Typography gutterBottom variant="h5" component="h2" style={{ fontSize: "17px", fontWeight: 500 }}>
                                    {row.name},
                                            <span>&nbsp;{row.subname.substring(0, 13)} {row.subname.length > 13 ? "..." : ""}  </span>
                                    <span style={{ fontWeight: 300 }}>{row.tags.join(", ")}  </span>
                                  </Typography>
                                  <div style={{ marginTop: "8px", fontSize: "12px", color: '#151b1e80' }}>
                                    <Link to={`/shop@${getOrganizationUID(row.sourcename)}`}>
                                      {row.sourcename}
                                    </Link>
                                  </div>
                                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: "10px", marginBottom: "10px" }}>
                                    <div key={index} className="uom" style={{ fontSize: "13px", fontWeight: 'bold' }}>
                                      <span>{`${row.count} ${row.uom} ${row.pack}`}</span>
                                    </div>
                                    {
                                      accessToken && row.user && sellerIds.indexOf(row.user.account.id) != -1 && (
                                        <div style={{ fontSize: "16px", fontWeight: 'bold' }} >
                                        <span>
                                          {`${val.substring(0, dec_pos)}`}<sup style={{ fontWeight: 300 }}> {`${val.substring(dec_pos + 1)}`}</sup>
                                        </span>
                                      </div>)
                                    }
                                  </div>
                                </CardContent>
                              </Card>
                            </Grid>
                          ) : (
                              <Grid item key={index} style={{ width: '240px' }} >
                                <Card className={classes.card}>
                                  <CardMedia
                                    className={classes.cardMedia}
                                    image={imageUrl}
                                    title=""
                                  />
                                  <CardContent className={classes.cardContent}>
                                    <Typography gutterBottom variant="h5" component="h2" style={{ fontSize: "17px", fontWeight: 500 }}>
                                      {row.name},<span>&nbsp;{row.subname}  </span>
                                      <span style={{ fontWeight: 300, fontSize: "13px" }}>{row.tags.join(", ")}  </span>
                                    </Typography>
                                    <div style={{ marginTop: "8px", fontSize: "12px", color: '#151b1e80' }}>
                                      <Link to={`/shop@${getOrganizationUID(row.sourcename)}`}>
                                        {row.sourcename}
                                      </Link>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: "10px", marginBottom: "10px" }}>
                                      <div key={index} className="uom" style={{ fontSize: "13px", fontWeight: 'bold' }}>
                                        <span>{`${row.count} ${row.uom} ${row.pack}`}</span>
                                      </div>
                                      {
                                      accessToken && row.user && sellerIds.indexOf(row.user.account.id) != -1 &&(
                                        <div style={{ fontSize: "16px", fontWeight: 'bold' }} >
                                          <span>
                                            {`${val.substring(0, dec_pos)}`}<sup style={{ fontWeight: 300 }}> {`${val.substring(dec_pos + 1)}`}</sup>
                                          </span>
                                        </div> )
                                      }
                                    </div>
                                  </CardContent>
                                </Card>
                              </Grid>
                            )
                        )
                      })
                    )
                  })
                  }
                </Grid>
              </div>
            )
        }
          <div style={{ paddingTop: 30 }}>
            <Pagination
              active={activePageIndex}
              count={Math.ceil(filteredData.length / 100)}
              onPageClick={this.onPageClick}
            />
          </div>
        </div> 
        {
          <Lightbox
            currentImage={currentImage}
            images={this.lightboxImages}
            isOpen={lightboxIsOpen}
            onClickImage={this.handleClickLightboxImage}
            onClickNext={this.gotoNextImage}
            onClickPrev={this.gotoPreviousImage}
            onClickThumbnail={this.gotoImage}
            onClose={this.closeLightbox}
            showThumbnails
          />
        }
        <Dialog
          open={open}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">Description</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              { dialogMessage }
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary" autoFocus>
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

/* istanbul ignore next */
const mapStateToProps = (/* state */) => ({
});

const wrappedStoreCardDetails = connect(mapStateToProps)(
  withStyles(styles)(injectIntl(StoreCardDetails)));

wrappedStoreCardDetails.displayName = 'StoreCardDetails';

export default wrappedStoreCardDetails;
